// Le logo de Zygosight — piste « Lentille » : deux cercles qui se croisent,
// leur intersection en couleur, un point au centre. Deux cercles, une
// intersection, un regard.
//
// UNE source pour le dessin : l'en-tête, la connexion, les pages publiques et
// les pages légales l'affichent tous d'ici. Seule la favicon, fichier statique,
// le recopie (`public/favicon.svg`).
//
// Les traits prennent la couleur du texte : le symbole suit le thème clair ou
// sombre sans variante à maintenir. Les deux autres couleurs sont des jetons
// (`--logo-accent`, `--logo-pupil`, dans `styles/tokens.css`).
import './ui.css';

/** Le trait et le point s'épaississent quand le symbole rétrécit — les trois
 *  graisses de la planche : grand format, pastille web, favicon. */
function weights(size: number): { stroke: number; pupil: number } {
  if (size >= 48) return { stroke: 6, pupil: 8 };
  if (size >= 28) return { stroke: 7, pupil: 9 };
  return { stroke: 10, pupil: 11 };
}

/** Le symbole seul. Décoratif : le nom est toujours écrit à côté. */
export function LogoMark({ size = 26 }: { size?: number }) {
  const { stroke, pupil } = weights(size);
  return (
    <svg className="logo-mark" viewBox="0 0 120 120" width={size} height={size} aria-hidden="true">
      <path className="logo-lens" d="M26.83 60 A36 36 0 0 1 93.17 60 A36 36 0 0 1 26.83 60 Z" />
      <circle cx="60" cy="46" r="36" fill="none" stroke="currentColor" strokeWidth={stroke} />
      <circle cx="60" cy="74" r="36" fill="none" stroke="currentColor" strokeWidth={stroke} />
      <circle className="logo-pupil" cx="60" cy="60" r={pupil} />
    </svg>
  );
}

/** Le nom, tel que le logo l'écrit : en minuscules, serré. La taille vient de
 *  l'endroit où il est posé (`className`). */
export function Wordmark({ className = '' }: { className?: string }) {
  return <span className={`logo-word ${className}`.trim()}>zygosight</span>;
}
